
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fourfiveseateracbus() {



    const cardData =
    {
        keyword: '45 Seater AC Bus On Rent in Pune',
        heading: 'Amruta Travels: 45 Seater AC Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers 45 Seater AC Bus on Rent in Pune, providing a spacious and comfortable travel solution for large groups. Whether it’s a corporate tour, school picnic, wedding transportation, or outstation trip, our fully air-conditioned 45-seater buses are designed to deliver a smooth and relaxed journey for every passenger.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

   "services": [
    {
      "name": "45 Seater AC Bus Hire in Pune",
      "description": "Amruta Travels offers 45-seater AC bus hire services in Pune, providing a comfortable and spacious travel solution for large groups. Whether it's for a corporate event, school trip, or outstation journey, our buses ensure a pleasant travel experience."
    },
    {
      "name": "45 Seater AC Bus Rental in Pune",
      "description": "Rent a fully air-conditioned 45-seater bus in Pune from Amruta Travels. Perfect for group outings, corporate events, or family trips, our buses offer ample space and comfort for your entire group."
    },
    {
      "name": "45 Seater AC Bus On Rent Pune",
      "description": "For a smooth and relaxing journey, rent a 45-seater AC bus from Amruta Travels in Pune. Ideal for both short and long-distance travel, our buses are equipped with comfortable seating, air conditioning, and experienced drivers."
    },
    {
      "name": "Rent 45 Seater AC Bus in Pune",
      "description": "Amruta Travels offers 45-seater AC buses for rent in Pune. Whether you're planning a wedding, corporate outing, or a picnic, our buses ensure comfortable and hassle-free travel for all group sizes."
    },
    {
      "name": "45 Seater AC Bus for Corporate Events",
      "description": "Make your corporate events in Pune seamless with our 45-seater AC bus rentals. Designed for comfort and convenience, our buses are perfect for transporting employees to seminars, conferences, and team-building events."
    },
    {
      "name": "45 Seater AC Bus for Wedding in Pune",
      "description": "Transport your wedding guests with ease and style using our 45-seater AC buses in Pune. Our buses are perfect for large wedding groups, ensuring comfort and luxury while traveling to and from wedding venues."
    },
    {
      "name": "45 Seater AC Bus for Picnic in Pune",
      "description": "Planning a group picnic? Rent a 45-seater AC bus from Amruta Travels for your trip. Our buses are spacious, well-maintained, and perfect for a comfortable and enjoyable picnic outing with family or friends."
    }
  ],
  "tableData": [
    ["45 Seater AC Bus Hire in Pune", "45 Seater AC Bus Rental in Pune"],
    ["45 Seater AC Bus On Rent Pune", "Rent 45 Seater AC Bus in Pune"],
    ["45 Seater AC Bus for Corporate Events", "45 Seater AC Bus for Wedding in Pune"],
    ["45 Seater AC Bus for Picnic in Pune"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Spacious and Comfortable 45 Seater AC Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers 45 seater AC buses on rent in Pune, ideal for large group transportation. Whether it's a school excursion, corporate trip, wedding event, or pilgrimage tour, our buses ensure a smooth, air-conditioned ride with plenty of space for passengers and luggage."
  },
  {
    "WhyChooseheading": "Perfect for Weddings, Corporate Events, and Group Travel",
    "WhyChoosedescription": "Our 45 seater AC buses are perfect for transporting large groups to events and outstation destinations. With ample seating, luggage space, and onboard comfort, they’re ideal for wedding guests, employees attending conferences, or group tour packages."
  },
  {
    "WhyChooseheading": "Modern Amenities for a Relaxed Travel Experience",
    "WhyChoosedescription": "Equipped with pushback seats, powerful air conditioning, LED lighting, music systems, and charging ports, our 45 seater buses offer a comfortable and fatigue-free experience for both short city rides and long-distance travel."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for 45 Seater Buses",
    "WhyChoosedescription": "We offer competitive and transparent pricing for 45 seater AC bus rentals in Pune. Our all-inclusive rates cover fuel, tolls, driver charges, and taxes—no hidden costs, just clear pricing to help you plan your group trip effectively."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "Our 45 seater buses are operated by experienced, courteous, and licensed drivers who ensure passenger safety and on-time arrivals. They are well-acquainted with Pune and outstation routes, ensuring a reliable travel experience."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Hassle-Free Travel",
    "WhyChoosedescription": "All our buses undergo regular maintenance and inspections to ensure top performance. Clean, sanitized, and road-ready—our 45 seater AC buses are prepared for both short-term events and long-distance tours."
  },
  {
    "WhyChooseheading": "Flexible Booking Options and Easy Process",
    "WhyChoosedescription": "Booking a 45 seater AC bus is quick and convenient with Amruta Travels. Whether online, over the phone, or in person, our booking process is simple. We offer hourly, daily, and multi-day rentals depending on your trip needs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Smooth Journey",
    "WhyChoosedescription": "Our customer service team is available 24/7 to help with bookings, route planning, and last-minute changes. We’re committed to making your journey seamless from the moment you book until your group reaches its destination."
  }
]


























    }

const faqData = [
  {
    question: 'Can I rent a 45-seater AC bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 45-seater AC buses for rent in Pune. These buses are perfect for large group transportation needs such as corporate outings, school trips, weddings, and pilgrimage tours.',
  },
  {
    question: 'Is the 45-seater AC bus available for both local and outstation trips?',
    answer: 'Absolutely. Our 45-seater AC buses are available for local travel within Pune as well as outstation journeys to destinations like Mumbai, Shirdi, Goa, Mahabaleshwar, and more.',
  },
  {
    question: 'What amenities are available in the 45-seater AC bus?',
    answer: 'Our 45-seater AC buses come equipped with features like push-back seats, air conditioning, ample luggage space, overhead storage, reading lights, and sound systems for a comfortable travel experience.',
  },
  {
    question: 'Do you provide a driver with the 45-seater AC bus rental?',
    answer: 'Yes, all our bus rentals include a professional and experienced driver who ensures safe, timely, and comfortable transportation for your group.',
  },
  {
    question: 'How much does it cost to rent a 45-seater AC bus in Pune?',
    answer: 'The rental cost depends on factors like the trip duration, distance, and travel route. Pricing typically starts from ₹32–₹40 per km. Contact us with your travel details for a customized quote.',
  },
  {
    question: 'Is the 45-seater AC bus suitable for long-distance travel?',
    answer: 'Yes, the 45-seater AC bus is ideal for long-distance journeys, offering spacious seating, air conditioning, and comfort for all passengers during extended travel.',
  },
  {
    question: 'Are your 45-seater buses sanitized and well-maintained?',
    answer: 'Yes, all our buses are thoroughly cleaned, sanitized, and regularly maintained to ensure safety, hygiene, and a smooth ride every time.',
  },
  {
    question: 'How do I book a 45-seater AC bus in Pune with Amruta Travels?',
    answer: 'You can easily book a 45-seater AC bus online through our website or by calling our customer support team. We’ll assist you with the booking process and any special requirements.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Abhay Patankar',
    role: 'Corporate Event Organizer, Pune',
    text: 'We hired a 45-seater AC bus from Amruta Travels for our annual company event. The bus was punctual, clean, and very comfortable. The driver was professional, and the journey was seamless.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Shilpa Kulkarni',
    role: 'School Coordinator',
    text: 'We booked a 45-seater AC bus for a school excursion. The bus was in excellent condition, air-conditioned, and very safe for students. Amruta Travels provided great service from start to finish!',
    rating: 5,
  },
];

















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const acBus45SeaterSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "45 Seater AC Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/45-seater-ac-bus.jpg", // Update with actual image URL
  "description": "Rent a 45-seater AC bus for your events in Pune. Perfect for corporate outings, weddings, picnics, and group travel. Comfortable and affordable bus rental services available.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000", // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/45-seater-ac-bus-on-rent-in-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | 45 Seater AC Bus on Rent in Pune | Wedding, Corporate Events & Picnics</title>
  <meta 
    name="description" 
    content="Book a 45-seater AC bus on rent in Pune for weddings, corporate events, picnics, and group travel. Affordable and comfortable bus rental services in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(acBus45SeaterSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fourfiveseateracbus;